import Vue from 'vue'
import Router from 'vue-router'
import isAdmin  from '@/middleware/isAdmin'
import isVendor from '@/middleware/isVendor'
import guest  from '@/middleware/guest'
import store from '@/store'
import isAgent from "@/middleware/isAgent"
import middlewarePipeline from './middlewarePipeline'

const login = () => import('@/views/login');
const AdminDashboard = () => import('@/views/admin/defaultComponent/DefaultContainer');
const AdminEditProfile = () => import('@/views/admin/edit_profile');
const AdminChangePassword = () => import('@/views/admin/change_password');
const ForgotPassword = () => import('@/views/forgot_password');
const ResetPassword = () => import('@/views/reset_password');

const CampaignList = () => import('@/views/admin/campaign/list');
const CampaignAdd = () => import('@/views/admin/campaign/add');
const CampaignEdit = () => import('@/views/admin/campaign/edit');
const PageNotFound = () => import('@/views/Page404')
const PageNotRespond = () => import('@/views/Page500')
const ShowResult = () => import('@/views/admin/marketing_event/show_result');
// const ImportContacts = () => import('@/views/admin/campaign/import_file');
const ContactList = () => import('@/views/admin/contact_manager/list');
const ContactAdd = () => import('@/views/admin/contact_manager/add');
const ContactEdit = () => import('@/views/admin/contact_manager/edit');
const ContactView = () => import('@/views/admin/contact_manager/list/view');
const ContactTrash = () => import('@/views/admin/contact_manager/trash/list');


const UserAdd = () => import('@/views/admin/user/add');
const UserList = () => import('@/views/admin/user/list');
const UserEdit = () => import('@/views/admin/user/edit');

const RoleAdd = () => import('@/views/admin/role/add');
const RoleList = () => import('@/views/admin/role/list');
const RoleEdit = () => import('@/views/admin/role/edit');

const WeightageList = () => import('@/views/admin/weightage/list');
const WeightageEdit = () => import('@/views/admin/weightage/edit');

const EventAdd = () => import('@/views/admin/marketing_event/add');
const EventEdit = () => import('@/views/admin/marketing_event/edit');
const EventList = () => import('@/views/admin/marketing_event/list');
const AssignVendor = () => import('@/views/admin/marketing_event/vendor');
const EditVendor = () => import('@/views/admin/marketing_event/edit_vendor');

const RequestContactList = () => import('@/views/admin/marketing_event/request_contact');
const ResponseContactList = () => import('@/views/admin/marketing_event/response_data/response_contact');
const ShowConflict = () => import('@/views/admin/marketing_event/response_data/show_conflict');

const AgentList = () => import('@/views/admin/marketing_event/agent/list');
const AgentAdd = () => import('@/views/admin/marketing_event/agent/add');
const AgentEdit = () => import('@/views/admin/marketing_event/agent/edit');
const AgentRequestContact =() => import('@/views/admin/marketing_event/agent/request_contact');

const ImportContactsFileList =() => import('@/views/admin/import_contact/list');
const ImportContactsFileAdd =() => import('@/views/admin/import_contact/add');
const ImportContactsFileEdit =() => import('@/views/admin/import_contact/edit');

const ImportedContactsList = () => import('@/views/admin/import_contact/response_data/response_contact');
const ImportedContactConflict =() => import('@/views/admin/import_contact/response_data/show_conflict');

const DirectMassImportFileList =() => import('@/views/admin/import_contact/direct_mass_import/list');
const DirectMassImportFileAdd =() => import('@/views/admin/import_contact/direct_mass_import/add');
const DirectImportedContactsList = () => import('@/views/admin/import_contact/direct_mass_import/response_data/response_contact');

const DuplicateMassImportFileList =() => import('@/views/admin/import_contact/duplicate_mass_import/list');
const DuplicateMassImportFileAdd =() => import('@/views/admin/import_contact/duplicate_mass_import/add');
const DuplicateImportedContactsList = () => import('@/views/admin/import_contact/duplicate_mass_import/response_data/response_contact');
const DuplicateImportedContactConflict =() => import('@/views/admin/import_contact/duplicate_mass_import/response_data/show_conflict');

const ExportContactsFileList =() => import('@/views/admin/export_contact/list');
const ExportContactsFileAdd =() => import('@/views/admin/export_contact/add');
const ExportContactsFileEdit =() => import('@/views/admin/export_contact/edit');

const DuplicateContactsList = () => import('@/views/admin/duplicate_contact/list_duplicate');
const DuplicateContactConflict =() => import('@/views/admin/duplicate_contact/show_duplicate');
//const UploadResponse = () impi

import UploadResponse from '@/views/admin/marketing_event/upload_response';
const UploadResponseList =() => import('@/views/admin/marketing_event/upload_response/list');

//VENDOR ROUTES 
const VendorDashboard = () => import('@/views/vendor/dashboard/DefaultContainer');
const VendorEventList = () => import('@/views/vendor/marketing_event/list');
const VendorEditProfile = () => import('@/views/vendor/edit_profile');
const VendorChangePassword = () => import('@/views/vendor/change_password');

//AGENT ROUTES
const AgentDashboard = () => import('@/views/agent/dashboard/DefaultContainer');
const AgentEventList = () => import('@/views/agent/marketing_event/list');
const AgentEditProfile = () => import('@/views/agent/edit_profile');
const AgentChangePassword = () => import('@/views/agent/change_password');

Vue.use(Router)

function configRoutes(){
    return [
    {
        path :'/500',
        name:"Page 500",
        component:PageNotRespond,
        meta:{ title: 'Server Error' }
    },
    {
        path :'',
        name:"Login",
        component:login,
        meta:{ title: 'Login',middleware : [guest ] }
    },
    {
        path :'/login',
        name:"Login",
        component:login,
        meta:{ title: 'Login',middleware : [guest ] }
    },
    {
        path: '/forgot-password',                    
        name: 'Forgot Password',
        component: ForgotPassword,
        meta:{title: 'Forgot Password',middleware : [guest ] }
    },
    { 
        path: '/reset-password/:token/:email', 
        name: 'Reset Password Form', 
        component: ResetPassword, 
        meta:{title: 'Reset Password',middleware : [guest ] } 
    },
    {
        path :'/admin',
        name:"Admin Dashboard",
        component:AdminDashboard,
        meta: {title: 'Admin | Dashboard', middleware : [isAdmin ] },
        children: [            
        {
            path: 'edit-profile/:id',                    
            name: 'Edit Admin Profile',
            component: AdminEditProfile,
            meta:{title: 'Admin | Edit Profile',middleware : [isAdmin ] },
        },
        {
            path: 'change-password/',                    
            name: 'Change Admin Password',
            component: AdminChangePassword,
            meta:{title: 'Admin | Change Password',middleware : [isAdmin ] },
        }, 
        {
            path: 'campaign',
            redirect: '/admin/campaign',
            name: 'Campaign',
            component: {
                render (c) { return c('router-view') },
            },
            meta:{title: 'Campaign | List', middleware : [isAdmin ] },
            children: [
            {
                path: '',
                name: 'List Campaign',
                component: CampaignList,
                meta:{title: 'Campaign | List',middleware : [isAdmin ] },
            },
            {
                path: 'add',
                name: 'Add Campaign',
                component: CampaignAdd,
                meta:{title: 'Campaign | Add',middleware : [isAdmin ] },
            },
            {
                path: 'edit/:id',
                name: 'Edit Campaign',
                component: CampaignEdit,
                meta:{title: 'Campaign | Edit',middleware : [isAdmin ] },
                        }/*,                        
                        {
                            path: 'import-contacts/:id',
                            name: 'Import Contacts',
                            component: ImportContacts,
                            meta:{title: 'Import Contacts | Edit',middleware : [isAdmin ] },
                        }*/
                        ]
                    },
                    {
                        path: 'contact-manager',
                        redirect: '/admin/contact-manager',
                        name: 'Contact Manager',
                        component: {
                            render(c) {
                                return c('router-view')
                            },
                        },
                        meta: {title: 'Contact | List', middleware: [isAdmin]},
                        children: [
                        {
                            path: '',
                            name: 'List Contacts',
                            component: ContactList,
                            meta: {title: 'Contact | List', middleware: [isAdmin]},                            
                        },
                        {
                            path: 'trash',
                            name: 'Trash Contacts',
                            component: ContactTrash,
                            meta: {title: 'Contact | Trash', middleware: [isAdmin]},                                
                        },

                        {
                            path: 'views/:id',
                            name: 'View Contacts',
                            component: ContactView,
                            meta: {title: 'Contact | Details', middleware: [isAdmin]},                                
                        },
                        {
                            path: 'add',
                            name: 'Add Contact',
                            component: ContactAdd,
                            meta:{title: 'Contact | Add',middleware : [isAdmin ] },
                        },
                        {
                            path: 'edit/:id',
                            name: 'Edit Contact',
                            component: ContactEdit,
                            meta:{title: 'Contact | Edit',middleware : [isAdmin ] },
                        }
                        ]
                    },{
                        path: 'event-manager',
                        redirect: '/admin/event-manager',
                        name: 'Event Manager',
                        component: {
                            render(c) {
                                return c('router-view')
                            },
                        },
                        meta: {title: 'Contact | List', middleware: [isAdmin]},
                        children: [
                        {
                            path: '',
                            name: 'List Event',
                            component: EventList,
                            meta: {title: 'Event | List', middleware: [isAdmin]},
                        },
                        {
                            path: 'add',
                            name: 'Add Event',
                            component: EventAdd,
                            meta:{title: 'Event | Add',middleware : [isAdmin ] },
                        },
                        {
                            path: 'edit/:id',
                            name: 'Edit Event',
                            component: EventEdit,
                            meta:{title: 'Event | Edit',middleware : [isAdmin ] },
                        },
                        {
                            path: 'assign-vendor/:id',
                            name: 'Assign Vendor',
                            component: AssignVendor,
                            meta:{title: 'Assign Vendor',middleware : [isAdmin ] },
                        },
                        {
                            path: 'edit-vendor/:id',
                            name: 'Edit Vendor',
                            component: EditVendor,
                            meta:{title: 'Edit Vendor',middleware : [isAdmin ] },
                        },                        
                        {
                            path: 'upload-response/:id',
                            name: 'Upload Response',
                            component: UploadResponse,
                            meta:{title: 'Upload Response',middleware : [isAdmin ] },
                        },

                        {
                            path: 'list-upload-response/:id',
                            name: 'Upload Response List',
                            component: UploadResponseList,
                            meta:{title: 'Upload Response List',middleware : [isAdmin ] },
                        },
                        {
                            path: ':id/reqest-contacts/:request_id',
                            name: 'Request Contacts',
                            component: RequestContactList,
                            meta:{title: 'Request Contact List',middleware : [isAdmin ] },
                        },
                        {
                            path: 'response-contacts/:id',
                            redirect: '/admin/event-manager/response-contacts/:id',
                            name: 'Response',
                            component: {
                                render(c) { return c('router-view') },
                            },
                            meta:{title: 'Response Contact List',middleware : [isAdmin ] },
                            children: [
                            {
                                path:'',
                                name:"Response Contacts",
                                component:ResponseContactList,
                                meta:{title:"Response Contact List",middleware:[isAdmin]}
                            },
                            {
                                path: 'show-contact/:conflict_id',
                                name: 'Show Conflict',
                                component: ShowConflict,
                                meta:{title: 'Show Conflict',middleware : [isAdmin ] },
                            }     
                            ],                            
                        },
                        {
                            path: 'agent/:id',
                            redirect: '/admin/event-manager/agent/:id',
                            name: 'Agent',
                            component: {
                                render(c) { return c('router-view') },
                            },
                            meta:{title: 'Agent Contact List',middleware : [isAdmin ] },
                            children: [
                            {
                                path:'',
                                name:"Agent List",
                                component:AgentList,
                                meta:{title:"Agent | List",middleware:[isAdmin]}
                            },
                            {
                                path:'add',
                                name:"Add Agent",
                                component:AgentAdd,
                                meta:{title:"Agent | Add",middleware:[isAdmin]}
                            },
                            {
                                path:'edit/:agent_req_id',
                                name:"Edit Agent",
                                component:AgentEdit,
                                meta:{title:"Agent | edit",middleware:[isAdmin]}
                            },
                            {
                                path:'contacts/:request_id',
                                name:"Agent Request Contacts",
                                component:AgentRequestContact,
                                meta:{title:"Agent | Contacts",middleware:[isAdmin]}
                            }
                            ],                            
                        },

                        {
                            path: 'show-result',
                            name: 'Show Result',
                            component: ShowResult,
                            meta:{title: 'Show Result | Edit',middleware : [isAdmin ] },
                        },
                        ]
                    },{
                        path: 'users',
                        redirect: '/admin/users',
                        name: 'Users',
                        component: {
                            render(c) {
                                return c('router-view')
                            },
                        },
                        meta: {title: 'Users | List', middleware: [isAdmin]},
                        children: [        
                        {
                            path:'',
                            name:"User List",
                            component:UserList,
                            meta:{title:"User | List",middleware:[isAdmin]}
                        },              
                        {
                            path: 'add',
                            name: 'Add User',
                            component: UserAdd,
                            meta:{title: 'User | Add',middleware : [isAdmin ] },
                        },
                        {
                            path: 'edit/:id',
                            name: "Edit User",
                            component: UserEdit,
                            meta:{title:"User | Edit",middleware : [isAdmin]}
                        }
                        ]
                    },{
                        path: 'roles',
                        redirect: '/admin/roles',
                        name: 'Roles',
                        component: {
                            render(c) {
                                return c('router-view')
                            },
                        },
                        meta: {title: 'Roles | List', middleware: [isAdmin]},
                        children: [        
                        {
                            path:'',
                            name:"Roles List",
                            component:RoleList,
                            meta:{title:"Role | List",middleware:[isAdmin]}
                        },              
                        {
                            path: 'add',
                            name: 'Add Role',
                            component: RoleAdd,
                            meta:{title: 'Role | Add',middleware : [isAdmin ] },
                        },
                        {
                            path: 'edit/:id',
                            name: "Edit Role",
                            component: RoleEdit,
                            meta:{title:"Role | Edit",middleware : [isAdmin]}
                        }
                        ]
                    },{
                        path: 'weightages',
                        redirect: '/admin/weightages',
                        name: 'Weightages',
                        component: {
                            render(c) {
                                return c('router-view')
                            },
                        },
                        meta: {title: 'Weightages | List', middleware: [isAdmin]},
                        children: [        
                        {
                            path:'',
                            name:"Weightage List",
                            component:WeightageList,
                            meta:{title:"Weightage | List",middleware:[isAdmin]}
                        },              
                        {
                            path: 'edit/:id',
                            name: "Edit Weightage",
                            component: WeightageEdit,
                            meta:{title:"Weightage | Edit",middleware : [isAdmin]}
                        }
                        ]
                    },
                    {
                        path: 'import-contact',
                        redirect: '/admin/import-contact',
                        name: 'Import Contact',
                        component: {
                            render(c) {
                                return c('router-view')
                            },
                        },
                        meta: {title: 'Import Contact | List', middleware: [isAdmin]},
                        children: [        
                        {
                            path:'',
                            name:"Import Contact List",
                            component:ImportContactsFileList,
                            meta:{title:"Import Contact | List",middleware:[isAdmin]}
                        },              
                        {
                            path: 'add',
                            name: 'Add Import Contact',
                            component: ImportContactsFileAdd,
                            meta:{title: 'Import Contact | Add',middleware : [isAdmin ] },
                        },
                        {
                            path: 'edit/:id',
                            name: "Edit Import Contact",
                            component: ImportContactsFileEdit,
                            meta:{title:"Import Contact | Edit",middleware : [isAdmin]}
                        },
                        {
                            path: 'imported-contacts/:id',
                            redirect: '/admin/import-contact/imported-contacts/:id',
                            name: 'Imported Contact',
                            component: {
                                render(c) { return c('router-view') },
                            },
                            meta:{title: 'Imported Contact List',middleware : [isAdmin ] },
                            children: [
                            {
                                path:'',
                                name:"Imported Contact List",
                                component:ImportedContactsList,
                                meta:{title:"Imported Contact | List",middleware:[isAdmin]}
                            },
                            {
                                path: 'imported-contacts-conflicts/:conflict_id',
                                name: 'Imported Contact Conflict',
                                component: ImportedContactConflict,
                                meta:{title: 'Imported Contact | Conflicts',middleware : [isAdmin ] },
                            }     
                            ],                            
                        },
                        ]
                    },{
                        path: 'direct-mass-import',
                        redirect: '/admin/direct-mass-import',
                        name: 'Direct Mass Import',
                        component: {
                            render(c) {
                                return c('router-view')
                            },
                        },
                        meta: {title: 'Direct Mass Import | List', middleware: [isAdmin]},
                        children: [        
                        {
                            path:'',
                            name:"Direct Mass Import List",
                            component:DirectMassImportFileList,
                            meta:{title:"Direct Mass Import | List",middleware:[isAdmin]}
                        },              
                        {
                            path: 'add',
                            name: 'Add Direct Mass Import',
                            component: DirectMassImportFileAdd,
                            meta:{title: 'Direct Mass Import | Add',middleware : [isAdmin ] },
                        },
                        {
                            path: 'direct-imported-contacts/:id',
                            redirect: '/admin/direct-mass-import/direct-imported-contacts/:id',
                            name: 'Direct Imported Contact',
                            component: {
                                render(c) { return c('router-view') },
                            },
                            meta:{title: 'Direct Mass Imported Contact List',middleware : [isAdmin ] },
                            children: [
                            {
                                path:'',
                                name:"Direct Mass Imported Contact List",
                                component:DirectImportedContactsList,
                                meta:{title:"Direct Mass Imported Contact | List",middleware:[isAdmin]}
                            }
                            
                            ],                            
                        },
                        ]
                    },{
                        path: 'duplicate-mass-import',
                        redirect: '/admin/duplicate-mass-import',
                        name: 'Duplicate Mass Import',
                        component: {
                            render(c) {
                                return c('router-view')
                            },
                        },
                        meta: {title: 'Duplicate Mass Import | List', middleware: [isAdmin]},
                        children: [        
                        {
                            path:'',
                            name:"Duplicate Mass Import List",
                            component:DuplicateMassImportFileList,
                            meta:{title:"Duplicate Mass Import | List",middleware:[isAdmin]}
                        },              
                        {
                            path: 'add',
                            name: 'Add Duplicate Mass Import',
                            component: DuplicateMassImportFileAdd,
                            meta:{title: 'Duplicate Mass Import | Add',middleware : [isAdmin ] },
                        },
                        {
                            path: 'duplicate-imported-contacts/:id',
                            redirect: '/admin/duplicate-mass-import/duplicate-imported-contacts/:id',
                            name: 'Duplicate Imported Contact',
                            component: {
                                render(c) { return c('router-view') },
                            },
                            meta:{title: 'Duplicate Mass Imported Contact List',middleware : [isAdmin ] },
                            children: [
                            {
                                path:'',
                                name:"Duplicate Mass Imported Contact List",
                                component:DuplicateImportedContactsList,
                                meta:{title:"Duplicate Mass Imported Contact | List",middleware:[isAdmin]}
                            },
                            {
                                path: 'duplicate-imported-contacts-conflicts/:conflict_id',
                                name: 'Duplicate Imported Contact Conflict',
                                component: DuplicateImportedContactConflict,
                                meta:{title: 'Duplicate Imported Contact | Conflicts',middleware : [isAdmin ] },
                            }  
                            
                            ],                            
                        },
                        ]
                    },{
                        path: 'export-contact',
                        redirect: '/admin/export-contact',
                        name: 'Export Contact',
                        component: {
                            render(c) {
                                return c('router-view')
                            },
                        },
                        meta: {title: 'Export Contact | List', middleware: [isAdmin]},
                        children: [        
                        {
                            path:'',
                            name:"Export Contact List",
                            component:ExportContactsFileList,
                            meta:{title:"Export Contact | List",middleware:[isAdmin]}
                        },              
                        {
                            path: 'add',
                            name: 'Add Export Contact',
                            component: ExportContactsFileAdd,
                            meta:{title: 'Export Contact | Add',middleware : [isAdmin ] },
                        },
                        {
                            path: 'edit/:id',
                            name: "Edit Export Contact",
                            component: ExportContactsFileEdit,
                            meta:{title:"Export Contact | Edit",middleware : [isAdmin]}
                        },
                        ]
                    },{
                        path: 'duplicate-contact',
                        redirect: '/admin/duplicate-contact',
                        name: 'Duplicate Contact',
                        component: {
                            render(c) {
                                return c('router-view')
                            },
                        },
                        meta: {title: 'Duplicate Contact | List', middleware: [isAdmin]},
                        children: [
                        {
                            path: '',
                            name: 'Duplicate Contact List',
                            component: DuplicateContactsList,
                            meta: {title: 'Duplicate Contact | List', middleware: [isAdmin]},                            
                        },{
                            path: 'duplicate-contact-conflicts/:conflict_id',
                            name: 'Duplicate Contact Conflict',
                            component: DuplicateContactConflict,
                            meta:{title: 'Duplicate Contact | Conflicts',middleware : [isAdmin ] },
                        }  
                        ]
                    }                    
                    ]
                },
                {
                    path :'/agent/',
                    name:"Agent Dashboard",
                    component:AgentDashboard,
                    meta:{title: 'Agent | Dashboard',middleware : [isAgent] },
                    children: [
                    {
                        path: 'marketing-event',
                        redirect: '/agent/marketing-event',
                        name: 'Agent Marketing Event',
                        component: {
                            render (c) { return c('router-view') },
                        },
                        meta:{title: 'Marketing Event | List', middleware : [isAgent ] },
                        children: [
                        {
                            path: '',
                            name: 'Agent Marketing Event List',
                            component: AgentEventList,
                            meta:{title: 'Marketing Event | List',middleware : [isAgent ] },
                        }
                        ]
                    },
                    {
                        path: 'edit-profile/:id',                    
                        name: 'Edit Agent Profile',
                        component: AgentEditProfile,
                        meta:{title: 'Agent | Edit Profile',middleware : [isAgent ] },
                    },
                    {
                        path: 'change-password/',                    
                        name: 'Change Agent Password',
                        component: AgentChangePassword,
                        meta:{title: 'Agent | Change Password',middleware : [isAgent ] },
                    },                
                    ]
                },
                {
                    path :'/vendor/',
                    name:"Vendor Dashboard",
                    component:VendorDashboard,
                    meta:{title: 'Vendor | Dashboard',middleware : [isVendor] },
                    children: [
                    {
                        path: 'marketing-event',
                        redirect: '/vendor/marketing-event',
                        name: 'Vendor Marketing Event',
                        component: {
                            render (c) { return c('router-view') },
                        },
                        meta:{title: 'Marketing Event | List', middleware : [isVendor ] },
                        children: [
                        {
                            path: '',
                            name: 'Vendor Marketing Event List',
                            component: VendorEventList,
                            meta:{title: 'Marketing Event | List',middleware : [isVendor ] },
                        }
                        ]
                    },
                    {
                        path: 'edit-profile/:id',                    
                        name: 'Edit Vendor Profile',
                        component: VendorEditProfile,
                        meta:{title: 'Vendor | Edit Profile',middleware : [isVendor ] },
                    },
                    {
                        path: 'change-password/',                    
                        name: 'Change Vendor Password',
                        component: VendorChangePassword,
                        meta:{title: 'Vendor | Change Password',middleware : [isVendor ] },
                    },                
                    ]
                },



                { path: "*", component: PageNotFound }
                ]
            }
            const router = new Router({
                mode: 'history',
                base: process.env.BASE_URL,
                linkActiveClass: 'active',    
                scrollBehavior: () => ({y: 0}),
                routes: configRoutes(),

            });

            router.beforeEach((to, from, next) => {    
                document.title = to.meta.title || 'Lead Database';
                if (!to.meta.middleware)
                    return next()

                const middleware = to.meta.middleware

                const context = {  to,  from, next, store }

                return middleware[0]({ ...context , next: middlewarePipeline(context, middleware, 1)  })

            })


            export default router;